import { AlertApiDto, CartApiDto } from '@b2x/storefront-api-js-client/src/dto';

import { CartSummaryA } from './CartSummaryA';
import { CartSummaryB } from './CartSummaryB';
import { CartPageProps } from './pages/CartPage';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface CartSummaryProps extends CartPageProps {
  blockingAlerts?: Array<AlertApiDto>;
  canMoveOn?: boolean;
  cart: CartApiDto;
}

export type CartSummaryVariants = 'A' | 'B';

const CartSummaryController = (
  props: PropsWithCustomComponent<CartSummaryProps> & { forceVariant?: CartSummaryVariants },
) => (
  <VariantsController<CartSummaryProps, CartSummaryVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: CartSummaryA, B: CartSummaryB },
      defaultComponent: CartSummaryA,
      name: 'CartSummary',
    }}
  />
);
export { CartSummaryController as CartSummary };
